import { render, staticRenderFns } from "./examEntrance.vue?vue&type=template&id=20007dea&scoped=true"
import script from "./examEntrance.vue?vue&type=script&lang=js"
export * from "./examEntrance.vue?vue&type=script&lang=js"
import style0 from "./examEntrance.vue?vue&type=style&index=0&id=20007dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20007dea",
  null
  
)

export default component.exports